"use client";

import { Footer } from "@/components/footer";
import { Navbar } from "@/components/navbar";
import { Card, Table } from "@heroui/react";

const SUBPROCESSORS = [
  { name: "Amazon Web Services", purpose: "Cloud infrastructure & hosting", location: "Europe" },
  { name: "Paddle", purpose: "Payment processing & billing", location: "United States" },
  { name: "Google Cloud", purpose: "OAuth authentication", location: "United States" },
  { name: "GitHub", purpose: "OAuth authentication", location: "United States" },
  { name: "Chatra", purpose: "Customer support chat", location: "United States" },
  { name: "Resend", purpose: "Transactional email delivery", location: "United States" },
  { name: "Cloudflare", purpose: "CDN, DNS & DDoS protection", location: "Global" },
];

export default function SubprocessorsPage() {
  return (
    <div className="marketing-surfaces min-h-screen bg-surface-base text-text-primary flex flex-col">
      <Navbar />

      <main className="heroui flex-1 px-5 sm:px-8 py-12 max-w-3xl mx-auto w-full">
        <h1 className="text-3xl font-semibold tracking-tight mb-2">Subprocessors</h1>
        <p className="text-base text-text-quaternary mb-8">Last updated: June 11, 2026</p>

        <Card
          variant="default"
          className="mb-10 gap-0! rounded-2xl border border-brand/30 bg-brand/6! p-6 shadow-none"
        >
          <p className="mb-2 text-sm font-semibold uppercase tracking-wide text-brand">
            In plain English
          </p>
          <p className="text-base leading-relaxed text-text-secondary">
            Encrata works with a small number of trusted third-party providers to run our
            service, including hosting, payments, login, support, email delivery, and security.
            These providers only receive the data they need to perform their role, and they are
            required to protect it under data protection terms consistent with our{" "}
            <a href="/legal/dpa" className="text-brand hover:underline">
              Data Processing Addendum
            </a>
            . When we add or remove important subprocessors, we will update this page and notify
            eligible customers where required.
          </p>
        </Card>

        <div className="space-y-8 text-base text-text-secondary leading-relaxed">
          <section>
            <p>
              Encrata engages the following third-party subprocessors to deliver the Service.
              Each subprocessor is bound by data protection obligations consistent with our{" "}
              <a href="/legal/dpa" className="text-brand hover:underline">
                Data Processing Addendum
              </a>
              .
            </p>
          </section>

          <section>
            <Table>
              <Table.Content aria-label="Subprocessors">
                <Table.Header className="**:[[role=columnheader]]:text-text-secondary">
                  <Table.Column isRowHeader>Subprocessor</Table.Column>
                  <Table.Column>Purpose</Table.Column>
                  <Table.Column>Location</Table.Column>
                </Table.Header>
                <Table.Body>
                  {SUBPROCESSORS.map((sp) => (
                    <Table.Row key={sp.name} id={sp.name}>
                      <Table.Cell className="font-medium text-text-primary">{sp.name}</Table.Cell>
                      <Table.Cell className="text-text-tertiary">{sp.purpose}</Table.Cell>
                      <Table.Cell className="text-text-tertiary">{sp.location}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table.Content>
            </Table>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-text-primary mb-3">Updates</h2>
            <p>
              We will update this page when subprocessors are added or removed. Customers with a
              signed DPA will be notified of material changes in advance and may object on
              reasonable data protection grounds.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-text-primary mb-3">Contact</h2>
            <p>
              Questions about our subprocessors? Email{" "}
              <a href="mailto:privacy@encrata.com" className="text-brand hover:underline">
                privacy@encrata.com
              </a>
              .
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
